<ng-container *appTranslate="let t">
  <div class="page">
    <ui-pageheader
      class="border-b-1 border-surface-border"
      [caption]="t('notifications.title')"
      [description]="
        t('notifications.since', { date: since | appDateTime: { dateStyle: 'short', timeStyle: 'medium' } : language })
      "
    >
      <menu class="row">
        <li>
          <new-ui-button icon="icon-[mi--left-arrow]" severity="secondary" (onClick)="back()" />
        </li>

        <li>
          <new-ui-button
            icon="pi pi-info-circle"
            [label]="t('notifications.openActivityLog')"
            (click)="openActivityLog()"
          />
        </li>

        <li>
          <new-ui-button
            [label]="t('common.settings')"
            icon="pi pi-cog"
            severity="secondary"
            [disabled]="isBusy"
            (onClick)="notificationListDialog.showDialog()"
          />
        </li>

        <li>
          <new-ui-button
            [label]="t('notifications.clearAll')"
            severity="secondary"
            icon="icon-[mi--edit-erase]"
            [disabled]="isBusy"
            (onClick)="clearAllNotifications()"
          />
        </li>
      </menu>
    </ui-pageheader>

    <article class="content">
      <new-ui-notification-list-dialog
        [notifications]="notifications"
        [since]="since"
        [settings]="settings"
        [isBusy]="isBusy"
        (settingsChanged)="updateSettings($event)"
        (notificationCleared)="clearNotification($event)"
        (allNotificationsCleared)="clearAllNotifications()"
        (activityLogOpened)="openActivityLog()"
        (closed)="close()"
      />
    </article>
  </div>
</ng-container>
